export default __webpack_public_path__ + "static/media/Andy Williams - Its the Most Wonderful Time of the Year (Official Audio).1d530137.mp3";